import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { AppOutline, FileOutline, UserOutline } from 'antd-mobile-icons';

const tabs = [
  { key: '/', title: '首页', icon: <AppOutline /> },
  { key: '/tickets', title: '工单', icon: <FileOutline /> },
  { key: '/profile', title: '我的', icon: <UserOutline /> },
];

export default function MobileLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const hideNav = ['/login', '/tickets/new'].includes(location.pathname) || /^\/tickets\/\d+/.test(location.pathname);

  return (
    <div className="mobile-layout">
      <main className="page-content" style={{
        paddingBottom: hideNav ? 0 : 'calc(56px + env(safe-area-inset-bottom, 0px))',
      }}>
        <Outlet />
      </main>
      {!hideNav && (
        <div className="tabbar-fixed">
          <div className="tabbar-inner">
            {tabs.map(item => (
              <button
                key={item.key}
                className={[
                  'tabbar-item',
                  location.pathname === item.key ? 'tabbar-active' : '',
                ].join(' ')}
                onClick={() => navigate(item.key)}
              >
                <span className="tabbar-icon">{item.icon}</span>
                <span className="tabbar-label">{item.title}</span>
              </button>
            ))}
          </div>
        </div>
      )}
      <style>{`
        .mobile-layout {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          background: #F5F7FA;
        }
        .page-content {
          flex: 1;
          overflow-y: auto;
          padding: 12px;
          -webkit-overflow-scrolling: touch;
        }
        .tabbar-fixed {
          position: fixed;
          left: 0; right: 0; bottom: 0;
          z-index: 999;
          background: #fff;
          border-top: 1px solid #E8ECF3;
          box-shadow: 0 -2px 12px rgba(0,0,0,0.06);
          padding-bottom: env(safe-area-inset-bottom, 0px);
        }
        .tabbar-inner {
          display: flex;
          height: 56px;
          padding: 0 8px;
        }
        .tabbar-item {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 2px;
          background: transparent;
          border: none;
          cursor: pointer;
          color: #8A9099;
          transition: color 0.2s ease, transform 0.15s ease;
          -webkit-tap-highlight-color: transparent;
          font-family: inherit;
          padding: 0;
        }
        .tabbar-active { color: #2E5BFF; }
        .tabbar-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
        }
        .tabbar-label {
          font-size: 11px;
          font-weight: 500;
          line-height: 1;
        }
        .tabbar-item:active {
          transform: scale(0.95);
          color: #2E5BFF !important;
        }
      `}</style>
    </div>
  );
}
